<template>
  <div id="map-container">
    <input
      type="text"
      class="form-control"
      id="pac-input"
      name="nombre"
      placeholder="Ingrese direccion del cliente"
    />
    <div id="map"></div>
  </div>
</template>

<style>
#app {
  height: 100%;
}
#map {
  height: 100%;
}
#map-container {
  height: calc(100% - 65px);
}

/* Optional: Makes the sample page fill the window. */
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

.container {
  height: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

#description {
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
}

#infowindow-content .title {
  font-weight: bold;
}

#infowindow-content {
  display: none;
}

#map #infowindow-content {
  display: inline;
}

.pac-card {
  margin: 10px 10px 0 0;
  border-radius: 2px 0 0 2px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  outline: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  background-color: #fff;
  font-family: Roboto;
}

#pac-container {
  padding-bottom: 12px;
  margin-right: 12px;
}

.pac-controls {
  display: inline-block;
  padding: 5px 11px;
}

.pac-controls label {
  font-family: Roboto;
  font-size: 13px;
  font-weight: 300;
}

#pac-input {
  background-color: #fff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  margin-left: 12px;
  padding: 0 11px 0 13px;
  text-overflow: ellipsis;
  width: 400px;
  margin-top: 15px;
}

#pac-input:focus {
  border-color: #4d90fe;
}

#title {
  color: #fff;
  background-color: #4d90fe;
  font-size: 25px;
  font-weight: 500;
  padding: 6px 12px;
}

#target {
  width: 345px;
}

.logoFarmalivio {
  margin-top: 0.1em;
}

.tituloCallCenter {
  text-align: center;
  font-family: "drina";
  color: #00837a;
  margin-top: 1em;
}
</style>

<script>
import axios from "axios";
import { sectorMapDivision } from '@/special/sectorMap.js'; 
export default {
  mounted() {
    /*Esta seccion toma el listado de las sucursales que vienen del back y crean un arreglo en javascript con estos datos para luego
      pintarlos con markers en el mapa la estructura del arreglo de sucurales es la siguiente:
      0=> codigo sucursal
      1=>lat
      2=>long
      3=>Direccion
      4=>Telefeono
      5=>horario
      6=>Consultorio(boolean)
      7=>Autofarmacia(boolan)
      8=>nombre_publico
      9=>horario Lunes a Viernes
      10=>horario Sabados
      11=>Domingos
      12=>extension
      13=>iconMarker
      14=>controlados
      */

    var sucursales = [];
    var arreglo_markers = [];
    var sucursales = [];

    var infowindow = "vacia";

    async function initMap() {
      arreglo_markers = [];
      // The location of Uluru
      var centro = { lat: 31.7034827, lng: -106.4161737 };
      // The map, centered at Uluru
      var map = new google.maps.Map(document.getElementById("map"), {
        zoom: 12,
        center: centro,
      });
      sectorMapDivision(map); 
      //Consultamos la url para traernos las sucursales que necesitamos
      let respuesta = await axios.get('/api/map_call_center')
          console.log(respuesta)
          respuesta.data.forEach(row => {
              sucursales.push([   
                  "suc"+row['id'],
                  row['gps_latitud'],
                  row['gps_longitud'],
                  row['direccion'],
                  row['telefono'],
                  row['horarios'],
                  row['consultorio'],
                  row['autoservicio'],
                  row['nombre_publico'],
                  row['horario-l-v'],
                  row['horario-s'],
                  row['horario-d'],
                  row['extension'],
                  row['iconMarker'],
                  row['controlados'],
                  row['nombre']
                  ])
          })
      console.log(sucursales)
      var i, marker, coordenadas;
      var iconBase = "/img/";
      for (i = 0; i < sucursales.length; i++) {
        var obj = {};
        var coordenadas = { lat: sucursales[i][1], lng: sucursales[i][2] };
        marker = new google.maps.Marker({
          position: coordenadas,
          map: map,
          title: sucursales[i][15],
          label: {
            color: "#504746",
            fontWeight: "bold",
            text: sucursales[i][15],
          },
          icon: {
            url: iconBase + sucursales[i][13],
            labelOrigin: new google.maps.Point(25, -10),
          },
        }); // 'marker-maps3.png'
        obj.marcador = marker;
        obj.id = "#" + sucursales[i][0];
        arreglo_markers.push(obj);
        var mensaje = formatear_infowindow(sucursales[i]);
        attachSecretMessage(marker, mensaje, "#" + sucursales[i][0]);
      }

      // Create the search box and link it to the UI element.
      var input = document.getElementById("pac-input");
      var searchBox = new google.maps.places.SearchBox(input);

      map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

      // Bias the SearchBox results towards current map's viewport.
      map.addListener("bounds_changed", function () {
        searchBox.setBounds(map.getBounds());
      });

      var markersUbicacion = [];
      // Listen for the event fired when the user selects a prediction and retrieve
      // more details for that place.
      searchBox.addListener("places_changed", function () {
        var places = searchBox.getPlaces();
        if (places.length == 0) {
          return;
        }
        // Clear out the old markers.
        markersUbicacion.forEach(function (markerUbicacion) {
          markerUbicacion.setMap(null);
        });
        markersUbicacion = [];

        // For each place, get the icon, name and location.
        var bounds = new google.maps.LatLngBounds();

        places.forEach(function (place) {
          if (!place.geometry) {
            console.log("Returned place contains no geometry");
            return;
          }

          console.log("ingreso aqui", places[0].geometry.viewport);
          console.log(
            "lat y Lng",
            place.geometry.location.lat(),
            place.geometry.location.lng()
          );
          var objeto_direccion = {};
          objeto_direccion.direccion = places[0].formatted_address;
          objeto_direccion.place_id = places[0].place_id;
          objeto_direccion.coord_i = place.geometry.location.lng(); //Este es el numero negativo
          objeto_direccion.coord_j = place.geometry.location.lat(); //Este es el numero positivo.
          //objeto_direccion.coord_i = places[0].geometry.viewport.Ra.i; //Este es el numero negativo
          //objeto_direccion.coord_j = places[0].geometry.viewport.Wa.i; //Este es el numero positivo.
          //Debe enviarse prinero el positivo y luego el negativo.
          objeto_direccion.link = `https://www.google.com/maps/search/?api=1&query=${objeto_direccion.coord_j},${objeto_direccion.coord_i}&query_place_id=${objeto_direccion.place_id}`;
          var copyToClipboard = JSON.stringify(objeto_direccion);

          /*BLOQUE DE CODIGO, APRA COPIAR EL JSON AL CLIPBOARD*/
          var dummy = document.createElement("textarea");
          document.body.appendChild(dummy);
          dummy.value = copyToClipboard
            .replace("á", "a")
            .replace("é", "e")
            .replace("í", "i")
            .replace("ó", "o")
            .replace("ú", "u");
          dummy.select();
          document.execCommand("copy");
          document.body.removeChild(dummy);
          // Create a marker for each place.
          markersUbicacion.push(
            new google.maps.Marker({
              map: map,
              icon: "/img/marker-client2.png",
              title: place.name,
              position: place.geometry.location,
              draggable: false,
              animation: google.maps.Animation.BOUNCE,
            })
          );
          console.log("Ubicacion buscada: ", markersUbicacion)
          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });
        map.fitBounds(bounds);
      });
    }

    //Esta funcion agrega un infowindow a cada uno de los markers, renderizados
    // en el mapa.

    function attachSecretMessage(marker, mensaje, cod_suc) {
      marker.addListener("click", function () {
        if (infowindow != "vacia") {
          infowindow.close();
        }
        infowindow = new google.maps.InfoWindow({
          content: mensaje,
        });

        infowindow.open(marker.getMap(), marker);
        //Remuevo fondo azul a todas las clases en caso que alguna la tenga, para limpiarlas.
        //   $("div .ficha-sucursal").removeClass("fondo-click-map");
        //Asigno el fondo azul solo a la sucursal que se le dio click en el marker
        //   $(cod_suc).addClass("fondo-click-map");
      });
    }

    //Aqui se establece el diseño html del la ventana InfoWindow que se mostrara
    // al hacer click en cada uno de los makers del mapa de google.
    function formatear_infowindow(array_sucursal) {
      var content =
        '<div class="container infowindow-clase">' +
        '<div class="row infowindow-titulo mx-auto info-row "><strong>Sucursal: </strong>' +
        array_sucursal[15] +
        " </div>" +
        '<div class="row mx-auto info-row "><strong>Nombre al público: </strong>' +
        array_sucursal[8] +
        " </div>" +
        '<div class="row mx-auto info-row"> <strong>Dirección: </strong>' +
        '<span class="infowindow-clase-contenido text-center">' +
        array_sucursal[3] +
        "</span> " +
        "</div>" +
        '<div class="row mx-auto info-row"> <strong>Consultorio: </strong>' +
        '<span class="infowindow-clase-contenido text-center">' +
        array_sucursal[6] +
        "</span>" +
        "</div>" +
        '<div class="row mx-auto info-row"> <strong>AutoServicio: </strong>' +
        '<span class="infowindow-clase-contenido text-center">' +
        array_sucursal[7] +
        "</span>" +
        "</div>" +
        '<div class="row mx-auto info-row"> <strong>Teléfono: </strong>' +
        '<span class="infowindow-clase-contenido text-center">' +
        array_sucursal[4] +
        "</span>" +
        "</div>" +
        '<div class="row mx-auto info-row"> <strong>Extensión: </strong>' +
        '<span class="infowindow-clase-contenido text-center">' +
        array_sucursal[12] +
        "</span>" +
        "</div>" +
        '<div class="row mx-auto info-row"> <strong>Horario Lunes a Viernes: </strong>' +
        '<span class="infowindow-clase-contenido text-center">' +
        array_sucursal[9] +
        "</span>" +
        "</div>" +
        '<div class="row mx-auto info-row"> <strong>Horario Sabados: </strong>' +
        '<span class="infowindow-clase-contenido text-center">' +
        array_sucursal[10] +
        "</span>" +
        "</div>" +
        '<div class="row mx-auto info-row"> <strong>Horario Domingo: </strong>' +
        '<span class="infowindow-clase-contenido text-center">' +
        array_sucursal[11] +
        "</span> </div>" +
        "</div>" +
        '<div class="row mx-auto info-row"> <strong>Controlados: </strong>' +
        '<span class="infowindow-clase-contenido text-center">' +
        array_sucursal[14] +
        "</span>" +
        "</div>" +
        "</div>";
      return content;
    }

    $(".row .ficha-sucursal").on("click", function (obj) {
      resultado = arreglo_markers.filter(function (marcador) {
        return marcador.id == "#" + obj.currentTarget.id;
      });
      google.maps.event.trigger(resultado[0].marcador, "click");
    });
    initMap();
  },
};
</script>
